import { supabase } from '../config/supabase'
import { Event, CreateEventData } from './EventService'

export interface ScrapedEventPayload {
  title: string
  short_description?: string
  description?: string
  website_link?: string
  image_url?: string
  start_date: string
  start_time: string
  end_date?: string
  end_time?: string
  time_zone?: string
  location?: string
  location_detail?: string
  modality?: 'in-person' | 'online' | 'hybrid'
}

export interface ImportFromLumaResult {
  eventId?: string
  error?: string
}

export async function importEventFromLuma(url: string, userId: string, userProfile?: { name?: string; email?: string; avatarUrl: string }): Promise<ImportFromLumaResult> {
  try {
    const { data, error } = await supabase.functions.invoke('luma-scraper', {
      body: { url }
    })

    if (error) {
      console.error('[LumaScraperService] invoke error:', error)
    } else {
      console.log('[LumaScraperService] raw data from edge:', data)
    }

    if (error) {
      return { error: error.message || 'Error invoking luma-scraper function' }
    }

    const payload = data as ScrapedEventPayload
    console.log('[LumaScraperService] parsed payload:', payload)

    if (!payload || !payload.title || !payload.start_date || !payload.start_time) {
      return { error: 'Datos incompletos desde el scraper' }
    }

    // Evitar duplicados por título usando solo ilike en la base
    const title = (payload.title || '').trim()
    if (title) {
      const { data: dupRows, error: dupError } = await supabase
        .from('events')
        .select('id')
        .ilike('title', `%${title}%`)
        .limit(1)

      if (!dupError && Array.isArray(dupRows) && dupRows.length > 0) {
        console.warn('[LumaScraperService] Duplicate title detected via ilike, aborting create')
        return { error: 'Ya existe un evento con este nombre' }
      }
    }

    const eventData: CreateEventData = {
      title: payload.title,
      short_description: payload.short_description,
      description: payload.description,
      website_link: payload.website_link,
      image_url: payload.image_url,
      start_date: payload.start_date,
      start_time: payload.start_time,
      end_date: payload.end_date,
      end_time: payload.end_time,
      time_zone: payload.time_zone,
      location: payload.location,
      location_detail: payload.location_detail,
      category: 'Otros',
      is_public: true,
      requires_approval: false,
      waiting_list: true
    }

    const { data: created, error: createError } = await Event.create(eventData, userId, userProfile)
    if (createError) {
      console.error('[LumaScraperService] Event.create error:', createError)
    } else {
      console.log('[LumaScraperService] Event created with id:', created?.id)
    }

    if (createError) {
      return { error: createError.message || 'No se pudo crear el evento' }
    }

    return { eventId: created?.id }
  } catch (e: any) {
    return { error: e?.message || 'Error inesperado importando evento' }
  }
}


